import React from 'react';

interface InputCardProps {
  title: string;
  children: React.ReactNode;
}

export const InputCard: React.FC<InputCardProps> = ({ title, children }) => {
  return (
    <div className="bg-white dark:bg-slate-800 p-6 rounded-xl shadow-md border border-gray-200 dark:border-slate-700 transition-colors">
      <h3 className="text-xl font-bold text-bp-slate dark:text-gray-100 mb-4 border-b dark:border-slate-600 pb-2">{title}</h3>
      <div className="space-y-4">{children}</div>
    </div>
  );
};

interface InputRowProps {
  label: string;
  id: string;
  children: React.ReactNode;
}

export const InputRow: React.FC<InputRowProps> = ({ label, id, children }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-2">
      <label htmlFor={id} className="font-semibold text-gray-700 dark:text-gray-300">
        {label}
      </label>
      <div className="md:col-span-2">{children}</div>
    </div>
  );
};